import { customer } from '@icabbi/api-gateway-client';
import { Authentication } from '@icabbi/vue-authentication';

const defaultState = {
  bankingAccountServiceClient: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  bankingAccountServiceClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (state.bankingAccountServiceClient === null) {
      const authentication = Authentication({ dispatch, getters: rootGetters });
      const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
      const bankingAccountServiceClient = new customer.BankingAccountServiceConnector({
        baseURL: process.env.VUE_APP_API_GATEWAY_URL,
        timeout: process.env.VUE_APP_HTTP_REQUEST_TIMEOUT,
      });
      bankingAccountServiceClient.httpClient.interceptors
        .response.use(undefined, error => authenticationFailureInterceptor(error));
      bankingAccountServiceClient.httpClient.interceptors
        .request.use(config => bearerTokenInterceptor(config));
      state.bankingAccountServiceClient = bankingAccountServiceClient;
    }
    return state.bankingAccountServiceClient;
  },
};

const actions = {
  async setDefaultBankingAccount(context, { account, fleetId, userIpAddress }) {
    const token = await context.dispatch('stripe/createToken', account, { root: true });
    const bankingAccountServiceClient = context.getters
      .bankingAccountServiceClient(context);
    if (token) {
      try {
        return bankingAccountServiceClient.setDefaultBankingAccount({ token: token.id, fleetId, userIpAddress });
      } catch (error) {
        // eslint-disable-next-line no-console
        context.dispatch('globalMessages/addError',
          { message: 'Error saving banking account information' },
          { root: true });
        return null;
      }
    } else {
      return null;
    }
  },
};
const mutations = {};

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations,
};
